module.exports = ":host{color:#232833}:host .modal-header{padding:15px 15px 0;border-bottom:0}:host .modal-body{padding:0 50px}:host .modal-body.is-block{min-height:375px}:host .modal-body h4{margin:5px 0 15px;font-weight:600}:host .modal-body p{margin-bottom:15px}:host .modal-body .error{margin-top:10px;font-size:13px;color:#d53434}:host .modal-footer{padding:35px 15px;border-top:0;text-align:center}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/merchants/areas/block-tables-modal/block-tables-modal.component.scss
// module id = 1154
// module chunks = 0